import React, { useState } from "react";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "../firebase";
import { useLocation, useNavigate } from "react-router-dom";
import bgImage from "../assets/maritime-bg.jpg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const query = useQuery();
  const navigate = useNavigate();

  const oobCode = query.get("oobCode");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setMessage("✅ Password has been reset successfully!");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      console.error("Reset error:", err.message);
      setError("❌ Failed to reset password. Try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Montserrat, sans-serif",
        position: "relative",
      }}
    >
      {/* Reset Card */}
      <div
        style={{
          background: "rgba(34, 40, 54, 0.85)",
          backdropFilter: "blur(6px)",
          padding: "35px",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0, 147, 255, 0.3)",
          width: "350px",
          textAlign: "center",
          color: "#DCE4F2",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Reset Password</h2>

        {message && (
          <div
            style={{
              backgroundColor: "#00D160",
              color: "white",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}

        {error && (
          <div
            style={{
              backgroundColor: "#FF4C4C",
              color: "white",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              background: "#0093FF",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s ease",
            }}
          >
            Save New Password
          </button>
        </form>
      </div>

      {/* Footer */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          background: "rgba(0,0,0,0.6)",
          color: "#DCE4F2",
          textAlign: "center",
          padding: "10px 0",
          fontSize: "14px",
        }}
      >
        Copyright © 2026. Equity Insight. All Rights Reserved.
      </div>
    </div>
  );
}

export default ResetPasswordPage;
